/**
 * Operator Watermark Component
 * Displays operator name as a watermark overlay on all screens to discourage screenshot sharing
 */

import React, { useEffect, useState } from 'react';
import { useAuth } from '../context/AuthContext';
import { Capacitor } from '@capacitor/core';
import './OperatorWatermark.css';

const OperatorWatermark = () => {
  const { operator } = useAuth();
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    // Show watermark in both native app and browser when operator is logged in
    // This provides security in both environments
    if (operator) {
      setIsVisible(true);
    } else {
      setIsVisible(false);
    }
  }, [operator]);

  if (!isVisible || !operator) {
    return null;
  }

  const operatorName = operator.name || operator.operator_code || 'Unknown Operator';
  const timestamp = new Date().toLocaleString();

  return (
    <div className="operator-watermark">
      <div className="watermark-content">
        <div className="watermark-name">{operatorName}</div>
        <div className="watermark-timestamp">{timestamp}</div>
        <div className="watermark-warning">CONFIDENTIAL - DO NOT SHARE</div>
      </div>
    </div>
  );
};

export default OperatorWatermark;

